import { Card, CardInfo, Image, ListWrapper, DeleteIcon, AddCardButton, CardHeader, Toolbar, OptionContent } from "./styles";
import { IBuildindCorretor } from "../../types";
import { FaTrash } from "react-icons/fa";
import { BsHouseAdd } from "react-icons/bs";
import { Select, Spin } from "antd";
import { useEffect, useState } from "react";
import { useAuth } from "../../context/auth";
import { useCallback } from "react";
import { maskMoney } from "../../utils/mask";

interface CardImovelListProps {
    imoveis: IBuildindCorretor[];
    addIMoveltoCarrossel: (imovel: IBuildindCorretor) => void;
    onDelete?: (id: number) => void;
    idImoveisEditing: number[]
    setIdImoveisEditing: (id: number[]) => void
}

export function CardImovelList({ imoveis, addIMoveltoCarrossel, onDelete, setIdImoveisEditing, idImoveisEditing }: CardImovelListProps) {
    const { Option } = Select;
    const { api, user } = useAuth();

    const [loading, setLoading] = useState(false);
    const [imoveisToAdd, setImoveisToAdd] = useState<IBuildindCorretor[]>([]);
    // const [querySearch, setQuerySearch] = useState('');
    const [imovelSelected, setImovelSelected] = useState<IBuildindCorretor | null>(null);
    const [page, setPage] = useState(0);
    const [hasMore, setHasMore] = useState(true);

    const getImoveis = useCallback(async () => {
        if (loading) return;

        setLoading(true);
        let currentPage = page;
        let hasMoreData = true;

        try {
            while (hasMoreData) {
                const res = await api.get(`/portal/building/list-building/${currentPage}`, {
                    params: {
                        portal: 'hub',
                        seller: `${user?.id_corretor}`,
                    },
                });

                const newImoveis = res.data;

                setImoveisToAdd(prev => {
                    const all = [...prev, ...newImoveis];
                    const unique = Array.from(new Map(all.map(item => [item.id, item])).values());
                    return unique;
                });

                hasMoreData = newImoveis.length > 0;
                currentPage++;
            }

            setPage(currentPage);
            setHasMore(false);
        } catch (err) {
            console.log("Erro ao carregar imóveis", err);
        } finally {
            setLoading(false);
        }
    }, [loading, user?.id_corretor, page, api]);





    // const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
    //     const target = e.currentTarget;
    //     if (target.scrollTop + target.offsetHeight >= target.scrollHeight - 50) {
    //         getImoveis();
    //     }
    // };

    const handleAddIMovel = (imovel: IBuildindCorretor | null) => {
        if (imovel) {
            addIMoveltoCarrossel(imovel);
            setImovelSelected(null);
        }

    }
    useEffect(() => {
        if (page === 0 && hasMore) {
            getImoveis();
        }
    }, [page, getImoveis, hasMore]);



    return (
        <ListWrapper>

            <Toolbar>
                <div style={{ width: '100%', display: "flex", alignItems: "start", gap: '2px', flexDirection: 'column' }}>

                    <div style={{ display: "flex", justifyContent: "center", gap: '3px' }}>
                        <BsHouseAdd size={20} />
                        <label> Pesquisar Imóvel</label>
                    </div>

                    <Select

                        labelInValue
                        value={imovelSelected ? { value: imovelSelected.id, label: imovelSelected.id + ' - ' + imovelSelected.descricao } : undefined}
                        showSearch
                        getPopupContainer={(triggerNode) => triggerNode.parentElement!}
                        placeholder="Digite o ID do imóvel"
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                            (option?.label?.toString().toLowerCase().includes(input.toLowerCase())) ?? false
                        }
                        onChange={(option) => {
                            const imovel = imoveisToAdd.find(i => i.id === option.value);
                            setImovelSelected(imovel || null);
                            setIdImoveisEditing(imovel ? [...idImoveisEditing, imovel.id] : idImoveisEditing);
                        }}
                        style={{
                            width: '100%',
                            height: '3rem',
                            borderRadius: '8px',
                            fontFamily: 'Poppins',
                            fontSize: '1rem',
                            marginBottom: '1rem',
                        }}
                        dropdownStyle={{ maxWidth: '100%', maxHeight: '300px', overflowY: 'auto' }}
                        notFoundContent={loading ? <Spin size="small" /> : 'Nenhum resultado'}
                        popupMatchSelectWidth={false}
                    >
                        {imoveisToAdd
                            .filter(item => !imoveis.some(sel => sel.id === item.id))
                            .map((item) => (
                                <Option key={item.id} value={item.id} label={`${item.id} - ${item.descricao} - ${item.is_aluguel === 1 ? item.valor_aluguel : ''} - ${item.is_venda === 1 ? item.valor_venda : ''}`}>
                                    <OptionContent>
                                        <span className="id">{item.id}</span>
                                        <span className="local">{item.is_aluguel === 1 ? maskMoney(item.valor_aluguel) : ''}</span>
                                        <span className="local">{item.is_venda === 1 ? maskMoney(item.valor_venda) : ''}</span>
                                        <span className="desc">{item.descricao}</span>
                                    </OptionContent>
                                </Option>
                            ))}
                        {loading && (
                            <Option disabled key="loading">
                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    <Spin size="small" />
                                </div>
                            </Option>
                        )}
                    </Select>

                </div>
                <AddCardButton onClick={() => handleAddIMovel(imovelSelected)}>Adicionar +</AddCardButton>
            </Toolbar>

            {imoveis.map((imovel, index) => (
                <Card key={index}>
                    <Image
                        src={imovel.arquivos?.[0]?.url || "https://portal-nogueira.s3.us-east-2.amazonaws.com/610bc5942d99d29ecda4-Group%201.png"}
                        alt={imovel.descricao}
                        $isPlaceholder={!imovel.arquivos?.[0]?.url}
                    />
                    <CardInfo>
                        <CardHeader>
                            <h2>{imovel.id} - {imovel.bairro}, {imovel.cidade}</h2>
                            <DeleteIcon onClick={() => onDelete?.(imovel.id)}>
                                <FaTrash />
                            </DeleteIcon>
                        </CardHeader>
                        <p style={{ color: "#666" }}>{imovel.descricao}</p>
                        <p><strong>A partir de:</strong> R$ {imovel.is_venda === 1 ? imovel.valor_venda.toLocaleString('pt-BR') : imovel.is_aluguel === 1 ? imovel.valor_aluguel.toLocaleString('pt-BR') : ''}</p>
                    </CardInfo>
                </Card>
            ))}
        </ListWrapper>
    );
}
